import React from "react";
import SearchSelect from "components/ui/SearchSelect";

const PRODUCT_OPTIONS = [
  { value: "Subscription", label: "Subscription" },
  { value: "Sandy Campaign", label: "Sandy Campaign" },
  { value: "Photo Editing", label: "Photo Editing" },
  { value: "SMS", label: "SMS" },
];

const ProductInput = ({ defaultValue = "", onSave }) => {
  const value = PRODUCT_OPTIONS.find((o) => o.value === defaultValue) ?? null;

  const handleChange = (option) => {
    if (option) onSave?.(option.value);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <SearchSelect
        value={value}
        onChange={handleChange}
        options={PRODUCT_OPTIONS}
        placeholder="— Select product —"
        searchable
      />
    </div>
  );
};

export default ProductInput;
export { PRODUCT_OPTIONS };
